import * as React from 'react'
import { styled } from '@mui/material/styles';

import {
  Button,
} from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default function UploadButton(props) {
  const {handleUpload} = props;
  
  const handleUploadButton = (e) => {
    handleUpload(e);
  }
  return (
    <Button
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      startIcon={<CloudUploadIcon />}
      sx={{ 
        margin: 2, 
        color: 'white', 
        background: '#7354EF',
        textTransform: 'none',
        right: '1rem'
      }}
    >
      Upload Template
      <VisuallyHiddenInput type="file" accept='application/vnd.openxmlformats-officedocument.presentationml.presentation' onChange={handleUploadButton} />
    </Button>
  );
}